// @flow
import { TiposVisitantesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    tiposVisitante: {},
    listaTiposVisitantes: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type TiposVisitantesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { tiposVisitante?: {} | null, listaTiposVisitantes?: [] | null, loading?: boolean, +value ?: boolean };

const TiposVisitantes = (state: State = INIT_STATE, action: TiposVisitantesAction): any => {
    // console.log(action);
    switch (action.type) {
        case TiposVisitantesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TiposVisitantesActionTypes.GET_TIPO: {
                    return {
                        ...state,
                        tiposVisitante: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case TiposVisitantesActionTypes.LIST_TIPOS: {
                    return {
                        ...state,
                        listaTiposVisitantes: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case TiposVisitantesActionTypes.ADD_TIPO: {
                    return {
                        ...state,
                        tiposVisitante: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposVisitantesActionTypes.UPDATE_TIPO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposVisitantesActionTypes.DELETE_TIPO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TiposVisitantesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TiposVisitantesActionTypes.GET_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        tiposVisitante: {},
                        loading: false,
                    };
                }
                case TiposVisitantesActionTypes.LIST_TIPOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaTiposVisitantes: [],
                        loading: false,
                    };
                }
                case TiposVisitantesActionTypes.ADD_TIPO: {
                    return {
                        ...state,
                        tiposVisitante: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposVisitantesActionTypes.UPDATE_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TiposVisitantesActionTypes.DELETE_TIPO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TiposVisitantesActionTypes.GET_TIPO:
            return { ...state, error: false, loading: true };
        case TiposVisitantesActionTypes.LIST_TIPOS:
            return { ...state, error: false, loading: true };
        case TiposVisitantesActionTypes.ADD_TIPO:
            return { ...state, error: false, loading: true };
        case TiposVisitantesActionTypes.UPDATE_TIPO:
            return { ...state, error: false, loading: true };
        case TiposVisitantesActionTypes.DELETE_TIPO:
            return { ...state, error: false, loading: true };
        case TiposVisitantesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                tiposVisitante: {},
                listaTiposVisitantes: [],
                formSubmited: false
            };
        case TiposVisitantesActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default TiposVisitantes;
